<ng-container *transloco="let t">
  <div class="order-totals-resume-wrapper">
    <div (click)="displayTotalDetails() && onShowTotalDetails()" class="total">
      <span>
        {{ totalLabel() }}:
        @if (displayTotalDetails()) {
          <span class="view-total-details">({{ viewDetailsLabel() }})</span>
        }
      </span>
      <span class="amount">
        @if (displayTotalDetails()) {
          <span class="amount-original">
            {{ endOrderTotals().totalAmount | currencyFormat }}
          </span>
        }
        <span class="amount-final">
          {{ endOrderTotals().finalAmount | currencyFormat }}
          @if (displayTotalDetails()) {
            <span class="amount-asterisc">*</span>
          }
        </span>
      </span>
    </div>
    @if (confirmOrderText()) {
      <pxw-button
        size="lg"
        color="cyan"
        display="block"
        [formId]="formId()"
        [mode]="formId() ? 'submit' : 'button'"
        [rounded]="true"
        [disabled]="disabled()"
        [loading]="saving()"
        (click)="onClickConfirm()"
      >
        {{ confirmOrderText() }}
      </pxw-button>
    }
  </div>
  <pxw-modal-dialog
    #totalDetailsDialog
    [title]="t('totalDetails.title')"
    type="modal"
    [showCloseButton]="true"
  >
    <pxw-icon icon="info" />
    <ng-template #modalContent>
      <app-order-total-details [orderTotals]="endOrderTotals()" />
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
